<template>
<div style="height: 100%; display: flex; flex-direction: column;">
    <input class="form-control" type="search" placeholder="Suche…" ref="SearchField" v-on:keydown.enter="onSearch" style="z-index: 10">
    <div style="flex: 1; overflow:auto;">
        <preloader v-if="loading"></preloader>
        <table class="table table-hover table-sm">
            <thead>
            </thead>
            <tbody>
            <tr v-for = "row in filteredRows" :key="row['row_number']"
                v-on:click="onSelectResult(row)"
                v-bind:class="{'table-active': row['row_number'] == active_row}">
                <td><span class='lemma' v-html="row['expression']"></span>&ensp;<span class='definition' v-html="row['definition']"></span>
                <div v-for = "result in row['results']" v-bind:key="result['row_number']">&emsp;<span v-html="result['expression']"></span></div></td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
</template>

<script>
  import Preloader from '@/components/Preloader';
  import axios from 'axios'
  
  export default {

    data () {
      return {
        rows: [],
        scoreLemma: 1,
        scoreCompleteWord: 2,
        scoreComplete: 4,
        scoreDirect: 16,
        active_row: 0,
        loading: false
      }
    },

    components: {
      Preloader
    },

    methods: {
      onSearch: function (event) {
        this.rows = [];
        this.loading = true;
        if (this.$refs.SearchField.value) {
          axios.post("/db/zettelkastensearch", {
              searchString: this.$refs.SearchField.value
            })
            .then(response => {
              this.loading = false;
              this.rows = response.data.rows;
            })
            .catch(e => {
              console.log(e);
            })
        }
      },

      onSelectResult: function (row) {
        const entry_ids = row.results.map(x => x.entry_id);
        this.$emit('lemma-selected', {lemma_id: row['lemma_id'], entry_ids: entry_ids, super: row['super']}); 
        this.active_row = row['row_number']
      }
    },

    computed: {
      filteredRows : function() {
        let r = [];
        let lemma;
        for (lemma of this.rows) {
          let lemma_new = lemma;
          lemma_new.results.map(x => Object.assign(x, {score: x.lemma*this.scoreLemma + x.complete*this.scoreComplete + x.complete_word*this.scoreCompleteWord + x.direct*this.scoreDirect}));
          lemma_new.results.sort((a, b) => a.entry_id === b.entry_id ? a.score < b.score : a.entry_id > b.entry_id);
          lemma_new.results = lemma_new.results.filter((x, i, a) => i === 0 || x.entry_id !== a[i-1].entry_id);
          lemma_new.score = lemma.results.reduce((max, value) => {return Math.max(max, value.score)}, 0);
          if(lemma_new.results[0].entry_id == -1 && lemma_new.results[0].score == lemma_new.score)
            lemma_new.results = []
          else
            lemma_new.results = lemma_new.results.filter(x => x.entry_id != -1);
          r.push(lemma_new);
        }
        r.sort((a, b) => a.score < b.score);
        return r;
      }
    }
  }
</script>

<style>

.definition .akkadian {
  font-style: italic;
}
.definition .ES:before {
  content: "ES = ";
  color: gray;
}
.definition .UGN:before {
  content: "UGN = ";
  color: gray;
}
.definition .translation:before {
  content: "„";
}
.definition .translation:after {
  content: "“";
}
.definition .description {
  color: gray;
}
.definition .propernoun {
  color: gray;
}

</style>


// WEBPACK FOOTER //
// src/components/ZettelkastenSearch.vue